<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-01 14:13:31
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-06-14 15:44:22
 * @FilePath: \nivara\src\views\demand\demandListView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div
    class="demandlist-container"
    v-loading="sellNowLoading"
    element-loading-text="Loading..."
  >
    <div class="demandlist-content">
      <div class="demandlist-search-box">
        <el-form :model="searchFormData" label-position="top">
          <el-form-item label="Type">
            <el-select v-model="searchFormData.type" size="large">
              <el-option label="ALL" value="" />
              <el-option
                v-for="item in searchFormData.demandTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Rate">
            <el-select v-model="searchFormData.rate" size="large">
              <el-option label="ALL" value="" />
              <el-option
                v-for="item in searchFormData.demandRateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Currency">
            <el-select v-model="searchFormData.currency" size="large">
              <el-option label="ALL" value="" />
              <el-option
                v-for="item in searchFormData.demandCurrencyList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Card Type">
            <el-select v-model="searchFormData.cardType" size="large">
              <el-option label="ALL" value="" />
              <el-option
                v-for="item in searchFormData.demandCardTypeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-demandlist-search" @click="searchDemand"
              >Search</el-button
            >
            <el-button class="btn-demandlist-cancel" @click="cancelSearchDemand"
              >Cancel</el-button
            >
          </el-form-item>
        </el-form>
        <div class="search-rules">
          Rules: <br /><br />1. CardSwap serves online 24 hours a day to quickly
          reach a deal around the clock. <br /><br />2. Seller provides
          effective picture, which is more conducive to improving revenue.
        </div>
      </div>
      <div class="demandlist-result-box">
        <div class="demandlist-title">
          All Offers
          <router-link to="/createDemand">
            <el-button>Post One</el-button>
          </router-link>
        </div>
        <el-table
          class="demandlist-table"
          :data="demandListData"
          :header-cell-style="headerCellStyle"
          border
          v-loading="demandListLoading"
        >
          <el-table-column prop="username" label="Buyer" align="center">
            <template #default="scope">
              <div class="demand-buyer-info">
                <div
                  class="buyer-info-name"
                  @click="lookBuyer(scope.row.user_id)"
                >
                  {{ scope.row.username }}
                </div>
                <div>
                  <el-image
                    :src="require('../../assets/images/good_review_active.png')"
                  />
                  {{ scope.row.comment_num }}
                </div>
                <div class="buyer-online-state">
                  <div class="buyer-online"></div>
                  Online
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="Card Type"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="avg_speed"
            label="Average Speed"
            align="center"
          >
            <template #default="scope">
              {{ scope.row.avg_speed }} minute
            </template>
          </el-table-column>
          <el-table-column
            prop="quota"
            label="Amount Of Demand"
            width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="avg_speed"
            label="Buying Quota"
            width="120"
            align="center"
          >
            <template #default="scope">
              {{ scope.row.min_buy_quota }} - {{ scope.row.max_buy_quota }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rate"
            label="Rate"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column label="Operation" align="center">
            <template #default="scope">
              <el-button type="text" @click="openSellNow(scope.row)"
                >Sell Now</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          hide-on-single-page
          layout="total, prev, pager, next"
          :page-size="10"
          :total="demandListTotal"
          @current-change="paginationCurrentChange"
        />
      </div>
    </div>
    <Popup ref="sellNowRef" title="Sell Gift Cards Now">
      <template #content>
        <div class="sell-now-content">
          <div class="table-title">
            Upload card secret
          </div>
          <el-table
            class="sell-now-table"
            :data="selectedDemandData"
            :header-cell-style="{
              background: '#DFDFDF',
              height: '50px',
              color: '#000000',
            }"
            border
          >
            <el-table-column prop="username" label="Buyer" align="center" />
            <el-table-column
              prop="category_name"
              label="Card Type"
              align="center"
            />
            <el-table-column
              prop="card_name"
              label="Purchase limit"
              align="center"
            />
            <el-table-column prop="rate" label="Exchange rate" align="center" />
          </el-table>
          <el-form
            class="sell-now-form"
            label-position="top"
            label-width="100px"
            :model="sellNowFormData"
          >
            <el-form-item label="Gift Card Amount">
              <el-input
                v-model="sellNowFormData.giftCardAmount"
                type="number"
                min="0"
                max="99999"
                @keydown="channelInputLimit"
                @input="giftCardAmountInput"
                style="text-align: center;"
              >
                <template #append>
                  {{ sellNowFormData.currency }}
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="Total Amount">
              <el-input
                v-model="sellNowFormData.totalAmount"
                type="number"
                min="0"
                @keydown="channelInputLimit"
              >
                <template #append>
                  {{ sellNowFormData.currencyName }}
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="Picture" required>
              <div v-loading="uploadLoading">
                <el-upload
                  class="sell-now-upload"
                  action="#"
                  list-type="picture-card"
                  :limit="10"
                  :auto-upload="false"
                  :on-change="uploadObs"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  multiple
                >
                  <el-icon><Plus /></el-icon>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
          <div class="sell-now-btn" v-if="isSellNow">
            <div class="sell-now" @click="sellNowDemand">Sell Now</div>
            <div class="previous-step" @click="previousStep">
              Previous step <span>(reselect bid)</span>
            </div>
          </div>
        </div>
      </template>
    </Popup>
    <el-dialog v-model="dialogVisible">
      <img
        class="sell-preview-images"
        :src="dialogImageUrl"
        alt="Preview Image"
        style="width: 100%;"
      />
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { getDemandListApi, userSubmitOrderApi } from "../../api/index";
import Popup from "@/components/popupView.vue";
import { ElNotification } from "element-plus";
import bus from "../../utils/eventBus";
import md5 from "js-md5";
import ObsClient from "@/utils/obs/dist/esdk-obs-browserjs.3.22.3.min.js";
import { randomFour } from "@/utils/utils";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  name: "DemandeList",
  components: { Popup },
  setup() {
    onMounted(() => {
      bus.emit("changeTitle", "All Offers");
      getDemandList();
    });
    const router = useRouter();
    const route = useRoute();
    const demandListPage = ref(0);
    const demandListTotal = ref(0);
    const sellNowRef = ref(null);
    const uploadLoading = ref(false);
    const dialogVisible = ref(false);
    const dialogImageUrl = ref("");
    const isSellNow = ref(false);
    const chatId = ref("");

    const state = reactive({
      // 搜索表单
      searchFormData: {
        type: "",
        rate: "",
        currency: "",
        cardType: "",
        demandTypeList: [
          {
            label: "BUY",
            value: "2",
          },
          {
            label: "SELL",
            value: "1",
          },
        ],
        demandRateList: [
          {
            label: "From low to high",
            value: "asc",
          },
          {
            label: "From high to low",
            value: "desc",
          },
        ],
        demandCurrencyList: [],
        demandCardTypeList: [],
      },
      // 需求列表
      demandListData: [],
      // 表头样式
      headerCellStyle: {
        "background-color": "#EFEFEF",
      },
      uploadObj: {
        size: 0,
        uidList: [],
        imagesUrlList: [],
      },
      sellNowFormData: {
        demandId: "",
        giftCardAmount: "",
        currency: "",
        totalAmount: "",
        currencyName: localStorage.getItem("currency_name"),
      },
      selectedDemandData: [],
    });
    // 分页变更
    const paginationCurrentChange = (e) => {
      demandListPage.value = e - 1;
      nextTick(() => {
        getDemandList();
      });
    };
    const searchDemand = () => {
      // if(state.searchFormData.type || state.searchFormData.rate || state.searchFormData.currency || state.searchFormData.cardType) {
      // }
      demandListPage.value = 0;
      nextTick(() => {
        getDemandList();
      });
    };
    // 取消搜索
    const cancelSearchDemand = () => {
      demandListPage.value = 0;
      state.searchFormData.type = "";
      state.searchFormData.rate = "";
      state.searchFormData.currency = "";
      state.searchFormData.cardType = "";
      nextTick(() => {
        getDemandList();
      });
    };
    // 查看买家
    const lookBuyer = (userId) => {
      router.push({ path: "/account", query: { user_id: userId } });
    };
    // 打开出售弹框
    const openSellNow = (demandObj) => {
      if (localStorage.getItem("token")) {
        chatId.value = demandObj.user_id;
        state.sellNowFormData.demandId = demandObj.id;
        state.selectedDemandData = [];
        // console.log(state.sellNowFormData.demandId);
        // 必须选择一个需求
        const index = state.demandListData.findIndex(
          (item) => item.id === demandObj.id
        );
        state.selectedDemandData.push(state.demandListData[index]);
        state.sellNowFormData.currency = state.demandListData[index].currency;
        // console.log(state.selectedDemandData);
        nextTick(() => {
          sellNowRef.value.open();
        });
      } else {
        router.push({ path: "/login", query: { redirect: route.fullPath } });
      }
    };
    // 禁止输入负号 和 文字
    const channelInputLimit = (e) => {
      let key = e.key;
      // 不允许输入'e'和'.'
      if (key === "e" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    };
    const giftCardAmountInput = (e) => {
      let rate = parseFloat(state.selectedDemandData[0].rate);
      console.log("当前需求汇率：", rate);
      let giftCardAmount = parseFloat(e);
      console.log("当前输入的礼品卡金额：", giftCardAmount);
      // 总金额 = 汇率 * 礼品卡金额
      console.log("计算出的总金额：", rate * giftCardAmount);
      state.sellNowFormData.totalAmount = parseFloat(
        rate * giftCardAmount
      ).toFixed(2);
    };
    // 上传图片到华为云
    const uploadObs = (e) => {
      // console.log(e);
      uploadLoading.value = true;
      isSellNow.value = false;
      state.uploadObj.size++;
      let deviceNo = md5(localStorage.getItem("device_no")).substring(0, 8);
      let currentDate = new Date() * 1000;
      let obsKey =
        "cdkey/" + deviceNo + "/" + currentDate + randomFour() + ".png";
      // console.log(obsKey);

      var obsClient = new ObsClient({
        access_key_id: "JG1WRK9TKWI1JFEF6URX", // 你的ak
        secret_access_key: "xLQrYaQjAtIIC4SQfVfZrhS2LjvAKqzYoDgQqqzC", // 你的sk
        server: "https://obs.af-south-1.myhuaweicloud.com", // 你的endPoint
        timeout: 5000,
      });
      obsClient.putObject(
        {
          Bucket: "yhobject", // 桶名
          Key: obsKey, // 路径 + 文件名
          SourceFile: e.raw,
        },
        function(err, result) {
          if (err) {
            console.error("Error-->" + err);
            uploadLoading.value = false;
            isSellNow.value = false;
          } else {
            // console.log(result);
            console.log("Status-->" + result.CommonMsg.Status);
            if (result.CommonMsg.Status === 200) {
              state.uploadObj.uidList.push(e.uid);
              state.uploadObj.imagesUrlList.push(
                "https://yhobject.obs.af-south-1.myhuaweicloud.com/" + obsKey
              );
              // console.log("uidList:", state.uploadObj.uidList);
              // console.log("imagesUrlList:", state.uploadObj.imagesUrlList);
              state.uploadObj.size--;
              if (state.uploadObj.size === 0) {
                uploadLoading.value = false;
                isSellNow.value = true;
                Notification({
                  title: "Tips",
                  message: "Upload Success",
                  type: "success",
                });
              }
            }
          }
        }
      );
    };
    const handleRemove = (e) => {
      // 图片所在数组的下标
      let index = state.uploadObj.uidList.indexOf(e.uid);
      console.log(e);
      // 根据下标删除对应图片
      state.uploadObj.uidList.splice(index, 1);
      state.uploadObj.imagesUrlList.splice(index, 1);
    };
    const handleExceed = () => {
      ElNotification({
        title: "Tips",
        message: "No More than 10 at a time",
        type: "error",
      });
    };
    const handlePictureCardPreview = (e) => {
      // console.log(e);
      dialogImageUrl.value = e.url;
      dialogVisible.value = true;
    };
    const sellNowLoading = ref(false);
    // 提交订单
    const sellNowDemand = () => {
      sellNowLoading.value = true;
      let data = {
        token: localStorage.getItem("token"),
        demand_id: state.sellNowFormData.demandId,
        images: state.uploadObj.imagesUrlList.join(","),
        channel_id: "1",
      };
      userSubmitOrderApi(data).then((res) => {
        console.log("userSubmitOrderApi：", res);
        if (res.data.success) {
          state.sellNowFormData.demandId = "";
          state.sellNowFormData.giftCardAmount = "";
          state.sellNowFormData.totalAmount = "";
          state.uploadObj.imagesUrlList = [];
          sellNowRef.value.close();
          ElNotification({
            title: "Tips",
            message: "Sell Success",
            type: "success",
          });
          sellNowLoading.value = false;
          nextTick(() => {
            bus.emit("refreshedMessagesNumber");
            getDemandList();
            router.push({
              path: "/chat",
              query: {
                chatId: chatId.value,
              },
            });
          });
        } else {
          sellNowLoading.value = false;
          ElNotification({
            title: "Tips",
            message: res.msg,
            type: "error",
          });
        }
      });
    };
    // 上一步
    const previousStep = () => {
      sellNowRef.value.close();
      state.uploadObj.imagesUrlList = [];
    };
    const demandListLoading = ref(false);
    // 获取需求列表 里面有所有卡类型
    const getDemandList = () => {
      demandListLoading.value = true;
      let data = {
        country_id: localStorage.getItem("country_id"),
        type: state.searchFormData.type,
        sort: state.searchFormData.rate,
        currency: state.searchFormData.currency,
        category: state.searchFormData.cardType,
        page: demandListPage.value,
      };
      // 获取需求列表
      getDemandListApi(data).then((res) => {
        console.log("getDemandListApi：", res);
        if (res.data.success) {
          if (res.data.data.list.length > 0) {
            state.demandListData = res.data.data.list;
            if (res.data.total) {
              demandListTotal.value = res.data.total;
            }
          } else {
            state.demandListData = [];
          }
          if (res.data.data.type_list.length > 0) {
            state.searchFormData.demandTypeList = res.data.data.type_list;
          }
          if (res.data.data.currency_list.length > 0) {
            state.searchFormData.demandCurrencyList =
              res.data.data.currency_list;
          }
          if (res.data.data.category_list.length > 0) {
            state.searchFormData.demandCardTypeList =
              res.data.data.category_list;
          }
        } else {
          ElNotification({
            title: "Tips",
            message: res.data.msg,
            type: "error",
          });
        }
        demandListLoading.value = false;
      });
    };
    return {
      demandListPage,
      demandListTotal,
      demandListLoading,
      sellNowRef,
      isSellNow,
      uploadLoading,
      dialogVisible,
      dialogImageUrl,
      channelInputLimit,
      giftCardAmountInput,
      uploadObs,
      handleRemove,
      handleExceed,
      handlePictureCardPreview,
      paginationCurrentChange,
      searchDemand,
      cancelSearchDemand,
      lookBuyer,
      openSellNow,
      sellNowLoading,
      sellNowDemand,
      previousStep,
      ...toRefs(state),
    };
  },
});
</script>
<style lang="less" scoped>
.demandlist-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  background-color: #f7f7f7;
  .demandlist-content {
    display: flex;
    .demandlist-search-box {
      max-width: 217px;
      padding: 20px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
      :deep(.el-form-item) {
        margin-bottom: 10px;
      }
      :deep(.el-form-item__label) {
        padding: 0;
        font-weight: bold;
        color: #000000;
      }
      :deep(.el-input__inner) {
        border-radius: 12px;
      }
      .btn-demandlist-search {
        margin-top: 20px;
        border-radius: 12px;
        background-color: #03004d;
        color: #ffffff;
      }
      .btn-demandlist-cancel {
        margin-top: 20px;
        border-color: #efefef;
        border-radius: 12px;
        color: #03004d !important;
        background-color: #efefef;
      }
      .search-rules {
        margin-top: 40px;
        padding: 20px;
        background-color: #fafafa;
        border-radius: 12px;
        color: #03004d;
        text-align: left;
        border: 1px dashed #dfdfdf;
      }
    }
    .demandlist-result-box {
      min-width: 1018px;
      padding: 20px;
      margin-left: 10px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      .demandlist-title {
        text-align: left;
        font-weight: bold;
        font-size: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          background-color: #03004d;
          color: #ffffff;
          border-radius: 12px;
        }
      }
      .demandlist-table {
        margin-top: 20px;
        border-radius: 12px;
        flex: 1;
        .demand-buyer-info {
          display: flex;
          flex-direction: column;

          .buyer-info-name {
            cursor: pointer;
          }
          .el-image {
            width: 12px;
            height: 12px;
          }
          .buyer-online-state {
            display: flex;
            justify-content: center;
            align-items: center;
            .buyer-online {
              width: 6px;
              height: 6px;
              margin-right: 5px;
              border-radius: 50%;
              background-color: #2dbf38;
            }
          }
        }
        .el-button {
          color: #2d43bf !important;
        }
      }
      .el-pagination {
        margin: 20px 0 50px 0;
        :deep(.el-icon-arrow-left) {
          margin: 0 10px;
        }
        :deep(.el-icon-arrow-right) {
          margin: 0 10px;
        }
      }
    }
  }
  .sell-now-content {
    padding: 36px;
    .table-title {
      font-size: 14px;
      text-align: left;
      color: #000000;
    }
    .sell-now-table {
      margin-top: 16px;
      border-radius: 10px;
    }
    .sell-now-form {
      :deep(.el-form-item) {
        margin-bottom: 10px;
      }
      :deep(.el-form-item__label) {
        padding: 0;
        font-weight: bold;
        color: #000000;
      }
      :deep(input::-webkit-outer-spin-button) {
        -webkit-appearance: none !important;
      }
      :deep(input::-webkit-inner-spin-button) {
        -webkit-appearance: none !important;
      }
      // :deep(input[type="number"]) {
      //   -moz-appearance: textfield !important;
      // }
      :deep(.el-input__inner) {
        text-align: center;
      }
    }
    .sell-now-upload {
      display: flex;
      flex-direction: column;
      :deep(.el-upload-list--picture-card) {
        text-align: left;
      }
      &:deep(.el-upload--picture-card) {
        min-width: 148px;
        line-height: unset;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    .sell-now-btn {
      margin-top: 40px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .sell-now {
        height: 48px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 48px;
        background-color: #03034d;
        color: #ffffff;
        border-radius: 12px;
        cursor: pointer;
      }
      .previous-step {
        height: 48px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 48px;
        background-color: #efefef;
        color: #03034d;
        border-radius: 12px;
        cursor: pointer;
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
